import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { drain } from '../../common/drain/drain';
import { ee } from '../../common/event-emitter/contextual-ee';
import { registerHandler } from '../../common/event-emitter/register-handler';
import { SessionEntity } from '../../common/session/session-entity';
import { LocalStorage } from '../../common/storage/local-storage.js';
import { DEFAULT_KEY } from '../../common/session/constants';
export function setupAgentSession(agentRef) {
  if (agentRef.runtime.session) return agentRef.runtime.session; // already setup

  var sessionInit = agentRef.init.session;
  agentRef.runtime.session = new SessionEntity({
    agentIdentifier: agentRef.agentIdentifier,
    key: DEFAULT_KEY,
    storage: new LocalStorage(),
    expiresMs: sessionInit === null || sessionInit === void 0 ? void 0 : sessionInit.expiresMs,
    inactiveMs: sessionInit === null || sessionInit === void 0 ? void 0 : sessionInit.inactiveMs
  }); // Retrieve & re-add all of the persisted setCustomAttribute|setUserId k-v from previous page load(s), if any was stored.

  var customSessionData = agentRef.runtime.session.state.custom;

  if (customSessionData) {
    agentRef.info.jsAttributes = _objectSpread(_objectSpread({}, agentRef.info.jsAttributes), customSessionData);
  }

  var sharedEE = ee.get(agentRef.agentIdentifier); // any calls to newrelic.setCustomAttribute(<persisted>) will need to be added to:
  // local info.jsAttributes {}
  // the session's storage API

  registerHandler('api-setCustomAttribute', function (time, key, value) {
    agentRef.runtime.session.syncCustomAttribute(key, value);
  }, 'session', sharedEE); // any calls to newrelic.setUserId(...) will need to be added to:
  // local info.jsAttributes {}
  // the session's storage API

  registerHandler('api-setUserId', function (time, key, value) {
    agentRef.runtime.session.syncCustomAttribute(key, value);
  }, 'session', sharedEE);
  drain(agentRef.agentIdentifier, 'session');
  return agentRef.runtime.session;
}